import { Backdrop, Box, CircularProgress, Drawer, Typography } from '@mui/material';
import { useState } from 'react';
import usePageTitle from '../../../Common/hooks/usePageTitle';
import TopBar from '../../../Layout/components/TopBar/TopBar';
import { ToolInfoDto } from '../../UserSearch/api/models/ToolInfoDto';
import { useToolsCapabilities } from '../../UserSearch/hooks/useToolsCapabilities';
import AdminToolGrid from '../components/AdminToolGrid';
import AdminToolManagement from '../components/AdminToolManagement';

const AdminToolView = (): JSX.Element => {
    const { tools, isLoading: isToolsLoading } = useToolsCapabilities();
    const [selectedTool, setSelectedTool] = useState<ToolInfoDto | null>(null);
    usePageTitle('Admin | Tools');

    const handleManageAccess = (tool: ToolInfoDto) => {
        setSelectedTool(tool);
    };

    const handleCloseDrawer = () => {
        setSelectedTool(null);
    };

    return (
        <div id='admintools' data-testid='admintools' style={{ height: '100%' }}>
            <TopBar>
                <Typography
                    variant='h4'
                    sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}
                >
                    Tools
                </Typography>
            </TopBar>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isToolsLoading}
            >
                <CircularProgress color='inherit' />
            </Backdrop>

            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4, px: 8 }}>
                <AdminToolGrid tools={tools} onManageAccess={handleManageAccess} />
            </Box>

            <Drawer anchor='right' open={selectedTool !== null} onClose={handleCloseDrawer}>
                {selectedTool && (
                    <AdminToolManagement tool={selectedTool} onClose={handleCloseDrawer} />
                )}
            </Drawer>
        </div>
    );
};

export default AdminToolView;
